export default __webpack_public_path__ + "static/media/facebookOutline.50f83d87.svg";